// import { makeAutoObservable, makeObservable, observable, configure } from "mobx"

import { decorate, observable } from "mobx"

const GMS = window.gms
const VC = GMS.VertxClient

export const STATUS = {
  CONNECTED: "CONNECTED",
  OFFLINE: "OFFLINE"
}

export const EVENT_TYPES = {
  SEQUENCE_INFO: "SEQUENCE_INFO",
  SEQUENCE_INITIALIZED: "SEQUENCE_INITIALIZED",
  STATUS: "STATUS",
}

const safeGetProp = (p, o) => p.reduce((xs, x) => (xs && xs[x]) ? xs[x] : null, o)


// Gere le timing et l'état de la période
class SequenceManager {

  periodIndex = null
  periodsTotal = null
  duration = null
  progress = null
  speedFactor = 1
  periodState = null
  currentTimeSecs = null
  timeout = null

  update(event) {
    // relou car les events ont tous une structure diffrente
    if(event.Type === EVENT_TYPES.SEQUENCE_INFO || event.Type === EVENT_TYPES.SEQUENCE_INITIALIZED) {

      let periods = safeGetProp(["Sequence", "Periods"], event)
      this.periodIndex = event.Sequence.CurrentPeriod
      this.periodsTotal =   periods && periods.length

      let periodInfos = periods && periods[this.periodIndex]



      if(periodInfos) {
        this.duration = periodInfos.DurationSec
      }

      this.periodState = event.Sequence.State
      this.progress = event.Sequence.Progress

    }
    else if (event.Type === EVENT_TYPES.STATUS ) {
      this.progress = event.PeriodProgress
      this.speedFactor = event.SpeedFactor
    }
    else {
      // c'est un event "EVENT" !
      if(event.PeriodDurationSec !== undefined) this.duration = event.PeriodDurationSec
      if(event.PeriodProgress !== undefined) this.progress = event.PeriodProgress
      // if(event.PeriodSpeedFactor !== undefined) this.speedFactor = event.PeriodSpeedFactor
      if(event.Type !== undefined) this.periodState = event.Type
      if(event.Period !== undefined) this.periodIndex = event.Period
    }


    this.calculateSecs()
    this.callInterUpdate()


  }
  calculateSecs() {
    if(this.duration === null) {
      this.currentTimeSecs = null
      return
    }
    let secs = this.duration * this.progress
    this.currentTimeSecs = Math.floor(secs)
  }

  callInterUpdate() {
    this.stop()
    if(this.speedFactor) {
      this.timeout = setTimeout(() => {
        if(this.periodState === "PERIOD_STARTED") {
          this.currentTimeSecs += 1
          this.callInterUpdate()
        }

      }, 1000 / this.speedFactor)
    }

  }

  stop() {
    clearTimeout(this.timeout)
    this.timeout = null
  }

}

decorate(SequenceManager, {
  periodIndex: observable,
  periodsTotal: observable,
  duration: observable,
  progress: observable,
  speedFactor: observable,
  periodState: observable,
  currentTimeSecs: observable,
  timeout: observable
})


// Gere la connecion au vertx, les infos du meeting, l'état de la connexion
class SGMSClient {
  client = null
  currentUser = null
  sequenceCmder = null
  meetings = []
  sequenceManager = null
  userCustomDatas = null

  currentMeeting = null
  currentMeetingUsers = []

  status = STATUS.CONNECTED

  // les ids des timeouts/intervals
  infosInterval = null
  offlineTimeout = null

  // les durées des timeouts
  infoIntervalDuration = 10000
  offlineTimeoutDuration = 2000


  constructor() {
    // makeObservable(this, {
    //   currentMeetingUsers: observable
    // })

    this.onMessageReceived = this.onMessageReceived.bind(this)
  }


  init(ip, port) {
    this.client = VC.CreateVertxClient(ip, port);
    this.sequenceCmder = this.client.sequencerCmdHelper.__class__
    this.sequenceManager = new SequenceManager()

    this.client.SIG_MeetingMessage.Add(this.onMessageReceived);
  }

  // vérifie la validité de universe/app
  universeAppGet(universe, app) {
    return new Promise( (resolve, reject) => {
      this.client.UniverseAppGet(universe, app, (success, msg, data) => {
        if(success) {
          resolve()
        }else {
          reject(msg)
        }
      })
    })
  }


  savedUserExists(LocalStorageUserKey) {
    try {
      return JSON.parse( localStorage.getItem(LocalStorageUserKey) )
    } catch(e) {
      console.log("error parsing", LocalStorageUserKey, "from localstorage")
      return false
    }
  }

  reconnect(universe, app, localStorageUserKey) {
    let prev_user = this.savedUserExists(localStorageUserKey)

    if(prev_user) {
      console.log("USING PREVIOUS ANONYMOUS USER")
      const {UserLogin, UserPassword} = prev_user
      return this.login(universe, app, UserLogin, UserPassword)
    } else {
      console.log("NEW ANONYMOUS USER")

      return new Promise( (resolve, reject) => {

        this.client.UserAnonymousAdd(universe, (success, msg, data) => {
          if (success) {
            try{
              localStorage.setItem(localStorageUserKey, JSON.stringify(data))

              this.login(universe, app, data.UserLogin, data.UserPassword)
              .then(() => resolve(data))

            } catch(err) {
              console.log(err)
            }
          } else {
            reject(msg)
          }
        })
      })
    }
  }


  loginKeycloak(universe, app, token) {
    return new Promise( (resolve, reject) => {
      this.client.UserConnectKeycloak(universe, app, token, (success, msg, data) => {
        if (success) {
          this.getUserId().then(id => {
            this.currentUser = data
            this.currentUser._id = id
            resolve()
          })
          .catch(reject)
        } else {
          console.log("Failed to Connect !", msg, data);
          reject(msg)
        }
      })
    })
  }

  login(universe, app, login, password) {
    return new Promise( (resolve, reject) => {
      this.client.UserConnect(universe, app, login, password, (success, msg, data) => {

        if(success) {
          this.getUserId().then(id => {
            this.currentUser = data
            this.userCustomDatas = VC.GetJsonObject(data)
            this.currentUser._id = id
            resolve()
          })
          .catch(reject)
        }
        else {
          reject(msg)
        }
      })
    })
  }

  logout() {
    return new Promise( (resolve, reject) => {
      this.client.UserDisconnect((success, msg, data) => {
        resolve() // on resolve dans tous les cas
      })

    })
  }

  userCreate(universe, login, password, pseudo) {

    const user = {
      Login: login,
      Password: password,
      Mail: login,
      Pseudo: pseudo,
      Universe: universe,
      LastName: "",
      FirstName: ""
    }
    return new Promise( (resolve, reject) => {
      this.client.UserAdd(user, (success, msg, data) => {
        if(success) resolve()
        else reject(msg)
      })
    })
  }

  userUpdateCustomData(datas) {
    return new Promise( (resolve, reject) => {
      this.client.UserUpdateCustomData(JSON.stringify(datas), (success, msg, data) => {
        if(success) {
          this.userCustomDatas = datas
          resolve()
        }
        else {
          reject()
        }
      })

    })
  }

  // returns the mongo id used in meetings sometime
  getUserId() {
    return new Promise( (resolve, reject) => {
      this.client.UserGetInfo((res, msg, data) => {
        if (res) {
          let userData = JSON.parse(data.DataArray);
          resolve(userData._id)
        } else {
          reject(msg)
        }
      })
    })
  }

  getUserMeetings() {
    return new Promise( (resolve, reject) => {
      this.client.MeetingGetAdministeredList( (success, msg, data) => {
        if(success) {
          let list = VC.GetJsonObject(data) // de la forme {id: name, id: name}
          let proms = Object.keys(list).map(id => this.meetingGetInfos(id))

          return Promise.all(proms)
          .then(data => {
            this.meetings = data
            resolve(data)
          })
          .catch(err => {
            reject(err)
          })
        }
        else {
          reject(msg)
        }
      })
    })
  }

  meetingGetInfos(meetingId) {
    return new Promise( (resolve, reject) => {
      this.client.MeetingGetInfos(meetingId, (success, msg, data) => {
        if(success) {
          let meetingInfos =  VC.GetJsonObject(data)

          if(!meetingInfos.MeetingCode) {
            this.meetingGetCode(meetingId)
            .then(codeData => {
              meetingInfos = {...meetingInfos, ...codeData}
              resolve(meetingInfos)
            })
            .catch(err => reject(err))
          } else {
            resolve(meetingInfos)
          }
        }
        else {
          reject(msg)
        }
      })
    })
  }
  meetingGetEventScores(meetingId, userId) {

    return new Promise( (resolve, reject) => {
      this.client.MeetingGetEventScores(meetingId, userId, (success, msg, data) => {
        if(success) {
          let scores = VC.GetJsonObject(data)
          resolve(scores[userId])
        }
        else {
          reject(msg)
        }
      })
    })
  }

  meetingGetCode(meetingId) {
    return new Promise( (resolve, reject) => {
      this.client.MeetingGetCode(meetingId, (success, msg, codeData) => {
        if(success) {
          resolve(codeData)
        } else {
          reject(msg)
        }
      })
    })
  }

  meetingCreate(meetingName, config) {
    return new Promise( (resolve, reject) => {
      this.client.MeetingCreate(meetingName, "", config, (success, msg, data) => {
        if(success) {
          resolve(data.MeetingID)
        }
        else {
          reject(msg)
        }
      })
    })
  }

  meetingDestroy(meetingId) {
    return new Promise( (resolve, reject) => {
      this.client.MeetingDestroy(meetingId, (success, msg, data) => {
        if(success) {
          this.meetings = this.meetings.filter(m => m._id !== meetingId)
          resolve()
        }
        else reject(msg)
      })
    })
  }

  meetingGetWithCode(code, login) {
    return new Promise( (resolve, reject) => {
      this.client.MeetingAddUserWithCode(code, login, (success, msg, data) => {
        if(success) {
          this.meetingGetInfos(data.MeetingID)
          .then(meeting => resolve(meeting))
          .catch(err => reject(err))
        }
        else {
          console.log("meetingGetWithCode msg", msg)
          reject(msg)
        }
      })
    })
  }


  meetingConnect(meeting) {
    return new Promise( (resolve, reject) => {
      this.client.UserMeetingConnect(meeting._id, (success, msg, data) => {
        if (success) {
          this.currentMeeting = meeting
          this.currentMeetingUsers = []
          resolve()
        }
        else {
          reject(msg)
        }
      })
    })
  }

  meetingGetConnectedUsersAndScores(meetingId){
    return new Promise( (resolve, reject) => {
      this.client.UserMeetingGetConnected(meetingId, (success, msg, usersData) => {
        if(success) {
          this.client.UserMeetingGetScores(meetingId, (success, msg, scoresData) => {
            if(success) {
              let meetingUsers = VC.GetJsonObject(usersData)

              this.currentMeetingUsers = []

              let scores = VC.GetJsonObject(scoresData)
              for(let id in meetingUsers) {
                this.currentMeetingUsers.push({id, pseudo: meetingUsers[id], scores: scores[id]})
              }
              resolve()
            }
            else {
              reject(msg)
            }
          })
        } else {
          reject(msg)
        }
      })
    })
  }



  startInfosInterval() {
    this.askForInfos() // immediat



    this.infosInterval = setInterval(()=>{
      this.askForInfos()
    }, this.infoIntervalDuration)
  }

  stopInfosInterval() {
    clearInterval(this.infosInterval)
  }

  askForInfos() {
    if(!this.client) return

    if(this.offlineTimeout) clearTimeout(this.offlineTimeout)
    this.offlineTimeout = setTimeout(() => {
      this.status = STATUS.OFFLINE
    }, this.offlineTimeoutDuration)

    const cmd = this.sequenceCmder.GetInfos()
    this.sendCmd(cmd);

  }


  onMessageReceived (meeting_id,from_user_id, message) {
    if(!this.currentMeeting) return

    if(meeting_id !== this.currentMeeting._id) return

    try {
      let m = JSON.parse(message)
      if(m.Name === "Score") {
        let user = this.currentMeetingUsers.find(user => user.id === from_user_id)
        if(user) user.scores = m.Data
      }

      else if(m.Name === "Sequencer") {
        const mData = JSON.parse(m.Data);
        // c'est un message de type event, on s'en sert pour la gestio de la séquence
        if (mData.Event) {
          this.sequenceManager.update(mData.Event)
        }

        // c'est un message de type info
        if(mData.Info) {
          // c'est un message de type sequenceInfo
          // ici on s'en sert pour
          // -la vérification qu'on est tjs connecté
          // - la gestion de la séquence
          // if(mData.Info.Type === "SEQUENCE_INFO") {
            this.offlineTimeout = clearTimeout(this.offlineTimeout)
            this.status = STATUS.CONNECTED

            this.sequenceManager.update(mData.Info)
          // }

        }

      }
    }catch(err) {
      console.log(err)
    }
  }


  sendCmd(cmd){
    if(!this.client) return
    return new Promise( (resolve, reject) => {
      this.client.UserMeetingSequencerCommand(this.currentMeeting._id, cmd, (success, msg, data) => {
        if(success) {
          resolve(data)
        }
        else {
          this.status = STATUS.OFFLINE
          reject()
        }
      })

    })
  }


  sendMessage(name, data) {
    if(!this.currentMeeting) return
    let meetingId = this.currentMeeting._id
    const msg = { Name: name, Data: data }
    this.client.UserMeetingSendToAll(meetingId, JSON.stringify(msg), false)
  }


  play() {
    const cmd = this.sequenceCmder.StartPeriod()
    return this.sendCmd(cmd)
    .then(() => this.askForInfos())
  }

  pause() {
    const cmd = this.sequenceCmder.PausePeriod()
    return this.sendCmd(cmd)
    .then(() => this.askForInfos())
  }

  updateSpeed(speed) {
    const cmd = this.sequenceCmder.UpdateSpeedFactor(speed)
    return this.sendCmd(cmd)
    .then(() => this.askForInfos())
}

  stopPeriod() {
    const cmd = this.sequenceCmder.StopPeriod()
    return this.sendCmd(cmd)
    .then(() => this.askForInfos())
  }
  stopSequence() {
    const cmd = this.sequenceCmder.StopSequence()
    return this.sendCmd(cmd)
    .then(() => this.askForInfos())
  }

  setPeriod(periodIndex) {
    const cmd = this.sequenceCmder.SetPeriod(periodIndex)
    return this.sendCmd(cmd)
    .then(() => this.askForInfos())
  }


  userMeetingSetScores(scores, score_id=null) {
    return new Promise( (resolve, reject) => {
      let meetingId = this.currentMeeting._id
      this.client.UserMeetingSetScores(meetingId, JSON.stringify(scores), score_id, (success, msg, data) => {
        if(success) {
          resolve(data)
        }else {
          console.log("error userMeetingSetScores", msg)
          reject(msg)
        }

      })

    })

  }

  userMeetingGetScores() {
    return new Promise( (resolve, reject) => {
      let meetingId = this.currentMeeting._id

      this.client.UserMeetingGetScores(meetingId, (success, msg, data) => {
        if(success) {
          resolve(data)
        }
        else {
          console.log("error userMeetingGetScores", msg)
          reject(msg)
        }
      })
    })
  }

  meetingGetFields(fields) {
    let meetingId = this.currentMeeting._id

    return new Promise( (resolve, reject) => {
      this.client.UserMeetingGetFields(meetingId, fields, (success, msg, data) => {
        if(success) {
          let meetingInfos =  VC.GetJsonObject(data)
          resolve(meetingInfos)
        }
        else {
          reject(msg)
        }
      })
    })
  }

  userMeetingGetCustomScores() {
    return this.meetingGetFields(["CustomScores"])
    .then(data => data.CustomScores)
  }




}

decorate(SGMSClient, {
  currentMeetingUsers: observable,
  sequenceManager: observable
})


export default new SGMSClient()